module.exports = __webpack_public_path__ + "static/media/boy-18.f193fc2d.svg";